const context = 'venue'

export const FETCH_VENUES = `${context}/FETCH_VENUES`
export const SELECT_VENUE = `${context}/SELECT_VENUE`
export const FETCH_VENUES_REQUESTED = `${context}/FETCH_VENUES_REQUESTED`
export const FETCH_VENUES_FAILED = `${context}/FETCH_VENUES_FAILED`
